import { isAxiosError } from "axios"

// The API's error envelope is `{ "detail": "<code>" }` (error-handling.md §5).
// Every management page read it with the same two ternaries; one place now.

/** The `detail` code of a failed request, or null (network, non-API error). */
export function apiErrorCode(err: unknown): string | null {
  if (!isAxiosError(err)) return null
  const detail: unknown = err.response?.data?.detail
  return typeof detail === "string" ? detail : null
}

/** The HTTP status of a failed request, for the log line. */
export function apiErrorStatus(err: unknown): number | null {
  return isAxiosError(err) ? (err.response?.status ?? null) : null
}
